<div>
    <p-avatar id="themeConfig" icon="fal fa-cogs" styleClass="mr-2" size="xlarge" shape="circle" (click)="onClickViewCustomizationConfig()"></p-avatar>
</div>
<p-dialog styleClass="w-4" position="bottom-right" [draggable]="false" [resizable]="false" header="Theme Customization" [modal]="true"
    [(visible)]="displayThemeCustomization">
    <div id="lightdark-panel" class="layout-config-section options">
        <h6>Color Mode</h6>
        <div class="flex justify-content-between">
            <div class="flex align-items-center">
                <p-radioButton name="layoutMode" value="light" [(ngModel)]="app.layoutMode" inputId="layoutMode1" (onClick)="onLayoutModeChange($event)"></p-radioButton>
                <label for="layoutMode1" class="ml-2">Light</label>
            </div>
            <div class="flex align-items-center">
                <p-radioButton name="layoutMode" value="dark" [(ngModel)]="app.layoutMode" inputId="layoutMode2" (onClick)="onLayoutModeChange($event)"></p-radioButton>
                <label for="layoutMode2" class="ml-2">Dark</label>
            </div>
            <div class="flex align-items-center">
                <p-radioButton name="layoutMode" value="dim" [(ngModel)]="app.layoutMode" inputId="layoutMode3" (onClick)="onLayoutModeChange($event)"></p-radioButton>
                <label for="layoutMode3" class="ml-2">Dim</label>
            </div>
        </div>
    </div>
    <div id="menumodes-panel" class="layout-config-section options">
        <h6 class="mt-2">Menu Mode</h6>
        <div class="flex justify-content-between">
            <div class="flex align-items-center">
                <p-radioButton name="menuMode" value="static" [(ngModel)]="app.menuMode" inputId="menuMode1"></p-radioButton>
                <label for="menuMode1" class="ml-2">Static</label>
            </div>
            <div class="flex align-items-center">
                <p-radioButton name="menuMode" value="overlay" [(ngModel)]="app.menuMode" inputId="menuMode2"></p-radioButton>
                <label for="menuMode2" class="ml-2">Overlay</label>
            </div>
            <div class="flex align-items-center">
                <p-radioButton name="menuMode" value="horizontal" [(ngModel)]="app.menuMode" inputId="menuMode3"></p-radioButton>
                <label for="menuMode3" class="ml-2">Horizontal</label>
            </div>
        </div>
    </div>
    <div id="menuthemes-panel" class="layout-config-section options">
        <h6 class="mt-2">Menu Theme</h6>
        <div class="flex justify-content-between">
            <div class="flex align-items-center">
                <p-radioButton name="menuTheme" [disabled]="app.layoutMode !== 'light'" value="light" [(ngModel)]="app.menuTheme" inputId="menuTheme1"></p-radioButton>
                <label for="menuTheme1" class="ml-2">Light</label>
            </div>
            <div class="flex align-items-center">
                <p-radioButton name="menuTheme" [disabled]="app.layoutMode !== 'light'" value="dark" [(ngModel)]="app.menuTheme" inputId="menuTheme2"></p-radioButton>
                <label for="menuTheme2" class="ml-2">Dark</label>
            </div>
            <div class="flex align-items-center">
                <p-radioButton name="menuTheme" [disabled]="app.layoutMode !== 'light'" value="dim" [(ngModel)]="app.menuTheme" inputId="menuTheme3"></p-radioButton>
                <label for="menuTheme3" class="ml-2">Dim</label>
            </div>
        </div>
    </div>
    <div id="topbarthemes-panel" class="layout-config-section options">
        <h6 class="mt-2">TopBar Mode</h6>
        <div class="flex justify-content-between">
            <div class="flex align-items-center">
                <p-radioButton name="topbarTheme" [disabled]="app.layoutMode !== 'light'" value="light" [(ngModel)]="app.topbarTheme" inputId="topbarTheme1"></p-radioButton>
                <label for="topbarTheme1" class="ml-2">Light</label>
            </div>
            <div class="flex align-items-center">
                <p-radioButton name="topbarTheme" [disabled]="app.layoutMode !== 'light'" value="dark" [(ngModel)]="app.topbarTheme" inputId="topbarTheme2"></p-radioButton>
                <label for="topbarTheme2" class="ml-2">Dark</label>
            </div>
            <div class="flex align-items-center">
                <p-radioButton name="topbarTheme" [disabled]="app.layoutMode !== 'light'" value="dim" [(ngModel)]="app.topbarTheme" inputId="topbarTheme3"></p-radioButton>
                <label for="topbarTheme3" class="ml-2">Dim</label>
            </div>
        </div>
    </div>
    <div id="outlined-panel" class="layout-config-section options">
        <h6 class="mt-2">Input Background</h6>
        <div class="flex justify-content-between">
            <div class="flex align-items-center">
                <p-radioButton name="inputStyle" value="outlined" [(ngModel)]="app.inputStyle" inputId="inputStyle1"></p-radioButton>
                <label for="inputStyle1" class="ml-2">Outlined</label>
            </div>
            <div class="flex align-items-center">
                <p-radioButton name="inputStyle" value="filled" [(ngModel)]="app.inputStyle" inputId="inputStyle2"></p-radioButton>
                <label for="inputStyle2" class="ml-2">Filled</label>
            </div>
        </div>
    </div>
</p-dialog>